import React from 'react';
import './style.scss';

export const UserText = ({ text, time, userImg }) => {
  return (
    <div className='txt-message user'>
      <div className='txt-des'>
        {text}
        <span>{time}</span>
      </div>
      <img src={userImg} alt='' id='profile-image' />
    </div>
  );
};

export const AiText = ({ text, time }) => {
  return (
    <div className='txt-message ai'>
      <img
        src='https://image.freepik.com/free-vector/profile-beautiful-smiling-young-woman-with-flower-her-hair_102172-291.jpg'
        alt=''
        id='profile-image'
      />
      <div className='txt-des'>
        {text}
        <span>{time}</span>
      </div>
    </div>
  );
};
